export const openRulesNav = (
  setRulesOpen: React.Dispatch<React.SetStateAction<boolean>>,
  setContentBlocksOpen: React.Dispatch<React.SetStateAction<boolean>>
) => {
  setContentBlocksOpen(false);
  setRulesOpen(true);
};

export const closeRulesNav = (
  setRulesOpen: React.Dispatch<React.SetStateAction<boolean>>
) => {
  setRulesOpen(false);
};

export const handleRulesFieldClick = (
  ruleName: string,
  templateFieldRulesRowData: any[],
  setSelectedRule: (rule: any) => void,
  setAddRulesModalShow: React.Dispatch<React.SetStateAction<boolean>>
): void => {

  const row = templateFieldRulesRowData.find(
    r => r.RuleName === ruleName
  );

  if (!row) return;

  setSelectedRule(row);

  setAddRulesModalShow(true);
};
